import React, { useEffect, useRef } from "react";
import classes from "./ScrollLTR.module.css"

const ScrollLTR = ({ dropStyle, downDropStyle, children }) => {

    const ref = useRef();

    return <div ref={ref} style={dropStyle} className={classes.Scroll}>
        <div className={classes.RTL} style={downDropStyle}>
            {children}
        </div>
    </div>
}

export default ScrollLTR;